/* Club (port di clubs.js) — cerca centri vicino Monza + dettaglio campi/orari. */
import { useEffect, useState } from "react";
import { ptapp } from "@/lib/ptapp";
import { Card, AccountSelect, Pill, COORD, asList } from "./_ui";

const nameOf = (t: any) => t.tenant_name || t.name || "Centro";
const cityOf = (t: any) => { const a = t.address || {}; return a.city || a.postal_code || a.street || t.city || ""; };
const sportsOf = (t: any): string[] => {
  let ids = t.sport_ids || t.supported_sports || t.sports || [];
  if (Array.isArray(ids)) ids = ids.map((s: any) => (s && typeof s === "object" ? (s.sport_id || s.id || s.name) : s));
  else if (ids && typeof ids === "object") ids = Object.keys(ids); else ids = [];
  return ids.filter(Boolean);
};

function Detail({ acct, t }: { acct: string; t: any }) {
  const tid = t.tenant_id || t.id;
  const [res, setRes] = useState<any[] | null>(null);
  const [hours, setHours] = useState<any | null>(null);
  useEffect(() => {
    let a = true; setRes(null); setHours(null);
    ptapp.call<any>(acct, "mgr", "v1/tenants/" + tid + "/resources").then((r) => a && setRes(asList(r))).catch(() => a && setRes([]));
    ptapp.call<any>(acct, "mgr", "v1/tenants/" + tid + "/ui/calendar_opening_hours").then((r) => a && setHours(r)).catch(() => a && setHours(null));
    return () => { a = false; };
  }, [acct, tid]);
  const days = Array.isArray(hours) ? hours : (hours && (hours.opening_hours || hours.days)) || [];
  return (
    <Card title={nameOf(t)}>
      <div className="mb-2 text-xs text-slate-400">{cityOf(t)}</div>
      <div className="mb-1 text-sm font-semibold text-slate-700">Campi {res ? `(${res.length})` : ""}</div>
      {res == null ? <div className="text-sm text-slate-500">carico…</div> : res.length === 0 ? <div className="text-sm text-slate-400">non disponibili</div> : (
        <div className="grid gap-2" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))" }}>
          {res.map((r: any, i: number) => { const p = r.properties || {}; return (
            <div key={i} className="rounded-lg border border-slate-200 p-2"><div className="flex items-center justify-between"><b className="text-sm text-slate-800">{r.name || r.resource_id}</b>{r.sport_id ? <Pill>{r.sport_id}</Pill> : null}</div><div className="text-xs text-slate-400">{[p.resource_type, p.resource_feature, p.resource_size].filter(Boolean).join(" · ")}</div></div>
          ); })}
        </div>
      )}
      {Array.isArray(days) && days.length ? (
        <div className="mt-3"><div className="mb-1 text-sm font-semibold text-slate-700">Orari</div>
          {days.map((d: any, i: number) => { const label = d.day_of_week || d.weekday || d.day || ""; const open = d.opening_time ?? d.open ?? d.start_time ?? d.from; const close = d.closing_time ?? d.close ?? d.end_time ?? d.to; return (
            <div key={i} className="flex justify-between py-0.5 text-sm"><span className="text-slate-700">{label}</span><span className="text-slate-400">{open != null && close != null ? `${open} – ${close}` : "chiuso"}</span></div>
          ); })}
        </div>
      ) : null}
    </Card>
  );
}

export default function Clubs() {
  const [acct, setAcct] = useState("staff");
  const [radius, setRadius] = useState(20000);
  const [sport, setSport] = useState("");
  const [list, setList] = useState<any[] | null>(null);
  const [sel, setSel] = useState<any | null>(null);

  const search = () => {
    setList(null); setSel(null);
    const params: any = { coordinate: COORD, radius, size: 50 }; if (sport) params.sport_id = sport;
    ptapp.call<any>(acct, "api", "v1/tenants", { params }).then((r) => setList(asList(r))).catch(() => setList([]));
  };
  useEffect(search, [acct]);

  return (
    <div className="mx-auto max-w-5xl space-y-4 p-4">
      <div className="flex flex-wrap items-center gap-2">
        <h2 className="mr-2 text-lg font-bold text-slate-900">Club</h2>
        <AccountSelect value={acct} onChange={setAcct} />
        <label className="text-sm text-slate-500">Raggio (m) <input type="number" min={500} step={500} value={radius} onChange={(e) => setRadius(+e.target.value)} className="w-28 rounded-md border border-slate-300 px-2 py-1.5 text-sm" /></label>
        <select value={sport} onChange={(e) => setSport(e.target.value)} className="rounded-md border border-slate-300 px-2 py-1.5 text-sm"><option value="">Tutti</option><option value="PADEL">Padel</option><option value="PICKLEBALL">Pickleball</option><option value="TENNIS">Tennis</option></select>
        <button onClick={search} className="rounded-md bg-moving-500 px-4 py-1.5 text-sm font-semibold text-white hover:opacity-90">Cerca</button>
      </div>

      {list == null ? <div className="text-sm text-slate-500">cerco centri…</div> : list.length === 0 ? <div className="text-sm text-slate-500">Nessun centro trovato.</div> : (
        <div className="grid gap-2" style={{ gridTemplateColumns: "repeat(auto-fill,minmax(240px,1fr))" }}>
          {list.map((t: any, i: number) => (
            <button key={i} onClick={() => setSel(t)} className="rounded-lg border border-slate-200 bg-white p-3 text-left hover:bg-slate-50">
              <div className="font-semibold text-slate-800">{nameOf(t)}</div><div className="text-xs text-slate-500">{cityOf(t) || "—"}</div>
              <div className="mt-1 flex flex-wrap gap-1">{sportsOf(t).map((s) => <Pill key={s}>{s}</Pill>)}</div>
            </button>
          ))}
        </div>
      )}

      {sel && <Detail acct={acct} t={sel} />}
    </div>
  );
}
